// CreateAssetModal — F8 (UI): criação de ativo a partir de ESCOPO LIVRE.
//
// O usuário descreve o que quer (escopo livre) → envia → o backend (Criador) lê a
// anatomia canônica, gera o ativo no contrato e materializa no storage do tenant.
// Mesmo caminho único de criação que os companions usam. Fire-and-forget: o ativo
// aparece na listagem quando pronto.
import { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from '@/components/ui/Dialog';
import { Button } from '@/components/ui/Button';
import { api } from '@/lib/api';

type AssetType = 'skill' | 'agent' | 'pipeline';

const LABEL: Record<AssetType, string> = { skill: 'skill', agent: 'agente', pipeline: 'pipeline' };

export function CreateAssetModal({
  type,
  open,
  onClose,
  onSubmitted,
  forceArchetype,
}: {
  type: AssetType;
  open: boolean;
  onClose: () => void;
  onSubmitted: (msg: string) => void;
  forceArchetype?: string;
}) {
  const [scope, setScope] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const label = forceArchetype === 'companion' ? 'companion' : LABEL[type];

  async function handleSubmit() {
    if (scope.trim().length < 10) {
      setError('Descreva o escopo com mais detalhe (mínimo 10 caracteres).');
      return;
    }
    setSubmitting(true);
    setError('');
    try {
      const r = await api.createAsset(type, scope.trim(), forceArchetype);
      onSubmitted(r.message || `Criando ${label} — aparece na listagem quando pronto.`);
      setScope('');
      onClose();
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Falha ao iniciar a criação.');
    } finally {
      setSubmitting(false);
    }
  }

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>Criar {label}</DialogTitle>
          <DialogDescription>
            Descreva TODO o escopo do que você quer criar — o que faz, entradas, saídas e regras. O
            RAIOS gera o {label} completo seguindo a anatomia canônica e materializa no seu tenant.
            Quanto mais claro o escopo, melhor o resultado.
          </DialogDescription>
        </DialogHeader>
        <textarea
          value={scope}
          onChange={(e) => setScope(e.target.value)}
          rows={9}
          autoFocus
          placeholder={`Ex.: uma ${label} que recebe [entrada], faz [passos] e devolve [saída], seguindo [regras]...`}
          className="w-full rounded-md border border-border bg-background px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-raios-brand/40"
        />
        {error && <p className="text-sm text-red-500">{error}</p>}
        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={submitting}>
            Cancelar
          </Button>
          <Button variant="brand" onClick={handleSubmit} loading={submitting}>
            Criar {label}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
